import { createUseStyles } from "react-jss";
import { foregroundColor, alpha, darken } from "../../theme/Mixins";

export default createUseStyles({
    buttonGroup: {
        display: "flex",
        paddingLeft: ({ theme }) => theme.BorderWidth,
    },
    groupButton: {
        boxShadow: ({ theme }) => `0 0 0 ${theme.BorderWidth}px ${theme.ControlBorderColor} inset`,
        marginLeft: ({ theme }) => -theme.BorderWidth,
        fontWeight: 700,
        background: ({ theme }) => theme.ControlBackground,
        color: ({ theme }) => foregroundColor(theme, theme.ControlBackground),
        userSelect: "none",
        cursor: "pointer",

        "&:first-child": {
            borderTopLeftRadius: ({ theme }) => theme.BorderRadius,
            borderBottomLeftRadius: ({ theme }) => theme.BorderRadius,
        },

        "&:last-child": {
            borderTopRightRadius: ({ theme }) => theme.BorderRadius,
            borderBottomRightRadius: ({ theme }) => theme.BorderRadius,
        },
    },
    groupButtonActive: {
        boxShadow: ({ theme }) =>
            `0 0 0 ${theme.BorderWidth}px ${darken(theme.PrimaryColor, 0.5)} inset`,
        background: ({ theme }) => theme.PrimaryColor,
        color: ({ theme }) => foregroundColor(theme, theme.PrimaryColor),
        zIndex: 2,
    },
    groupButtonDisabled: {
        color: ({ theme }) => alpha(foregroundColor(theme, theme.ControlBackground), 0.6),
        cursor: "default",
    },
    groupButtonGrid: {
        padding: [8, 16],
        lineHeight: "34px",
    },
    groupButtonNoGrid: {
        padding: ({ theme }) => [[0, 9 + theme.BorderWidth]],
        lineHeight: "1.6em",
    },
});
